import {S3Client} from "@aws-sdk/client-s3";

const REGION = process.env.PUBLIC_AWS_GUEST_REGION;

// AWS SDK v3 has no global config, so we keep the credentialed client here and
// share it between the page (which fetches guest credentials) and the uploader.
let s3Client = null;

export const initS3Client = (credentials) => {
    s3Client = new S3Client({
        region: REGION,
        credentials: {
            accessKeyId: credentials.access_key_id,
            secretAccessKey: credentials.secret_access_key,
        },
    });

    return s3Client;
};

export const getS3Client = () => s3Client;
